import { ICONS_INSIGHTS } from "@/const/insights-constants"
import { InsightsCell } from "@/molecules/InsightsCell"

import type { TFunction } from "@/hooks/useTranslation"
import type { InsightsImageCellProps } from "./InsightsImageCell.types"

export const InsightsImageCell = (t: TFunction) =>
  function InsightsImageCell(
    values: InsightsImageCellProps,
    record?: { key: string }
  ) {
    return (
      <InsightsCell
        hide
        id={record?.key}
        items={[
          ICONS_INSIGHTS.runtime,
          ICONS_INSIGHTS.publicImage,
          ICONS_INSIGHTS.fromBaseImage,
          ICONS_INSIGHTS.isThirdParty,
          ICONS_INSIGHTS.aiInsight
        ]}
        values={values}
        t={t}
      />
    )
  }
